import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW1709Model } from "../kymw1709.model";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";

// レスポンス構造
export type GetUploadImageInfoResponse = {
  ImageFile1: string,		
  ImageFileName1: string,
  ImagePixel1: string,
  ImageFile2: string,
  ImageFileName2: string,
  ImagePixel2: string,
  ImageFile3: string,
  ImageFileName3: string,
  ImagePixel3: string,
}

/**
 * アップロード画像情報取得
 * 
 */
@Injectable()
export class GetUploadImageInfoService extends PlessJsonResponderSub<GetUploadImageInfoResponse> {
  model: KYMW1709Model;
  successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   * @returns 
   */
  getBody() {
    return new PlessRequest({
      parameter: {
        ImageFileName: this.model.imageFileName,
      }
    })
  }

  /**
   * API呼び出し
   * @param model 
   * @param successFunc 
   */
  execute(model:KYMW1709Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getUploadImageInfo', this.getBody())
  }

  /**
   * API成功後処理
   * @param data 
   */
  success(data: GetUploadImageInfoResponse): void {
    this.model.setImageFileName(data);
    if ( this.successFunc ){
      this.successFunc();
    }
  }
}